/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  InvitationCenterLogic,
  InvitationCenterLogicInterface,
} from "../../../contracts/invitationCenter/InvitationCenterLogic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "getRegisterDetail",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "index",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "address",
            name: "inviter",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "invitationCode",
            type: "bytes32",
          },
        ],
        internalType: "struct InvitationCenterType.RecordWithIndex[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "inviteeRecordsAt",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        internalType: "address",
        name: "invitee",
        type: "address",
      },
    ],
    name: "inviteeRecordsContains",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "inviteeRecordsLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "input",
        type: "bytes32",
      },
    ],
    name: "inviterCodeToAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "inviterRecords",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "address",
            name: "inviter",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "invitationCode",
            type: "bytes32",
          },
        ],
        internalType: "struct InvitationCenterType.Record",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "isRegistered",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "address",
            name: "inviter",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "invitationCode",
            type: "bytes32",
          },
        ],
        internalType: "struct InvitationCenterType.Record[]",
        name: "params",
        type: "tuple[]",
      },
    ],
    name: "manualRegister",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "inviterCode",
        type: "bytes32",
      },
    ],
    name: "registerInviter",
    outputs: [
      {
        internalType: "address",
        name: "inviter",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "registerApplier",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "inviterCode",
        type: "bytes32",
      },
    ],
    name: "registerInviterAuth",
    outputs: [
      {
        internalType: "address",
        name: "inviter",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "registerApplier",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "inviterCode",
        type: "bytes32",
      },
    ],
    name: "registerInviterManager",
    outputs: [
      {
        internalType: "address",
        name: "inviter",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "registerApplier",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "selfCode",
        type: "bytes32",
      },
    ],
    name: "registerInviterWithCodeAuth",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "registeredAccountAt",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "registeredAccountContains",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "registeredAccountLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "registeredInvitationCodeAt",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "input",
        type: "bytes32",
      },
    ],
    name: "registeredInvitationCodeContains",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "registeredInvitationCodeLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type InvitationCenterLogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: InvitationCenterLogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class InvitationCenterLogic__factory extends ContractFactory {
  constructor(...args: InvitationCenterLogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<InvitationCenterLogic> {
    return super.deploy(overrides || {}) as Promise<InvitationCenterLogic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): InvitationCenterLogic {
    return super.attach(address) as InvitationCenterLogic;
  }
  override connect(signer: Signer): InvitationCenterLogic__factory {
    return super.connect(signer) as InvitationCenterLogic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): InvitationCenterLogicInterface {
    return new utils.Interface(_abi) as InvitationCenterLogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): InvitationCenterLogic {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as InvitationCenterLogic;
  }
}
